export const headerData = [
  {
    key: 'name',
    header: 'Name',
  },
  {
    key: 'assessmentId',
    header: 'Assessment ID',
  },
  {
    key: 'actionCandidateId',
    header: 'Action Candidate ID',
  },
  {
    key: 'actionStatus',
    header: 'Status',
  },
  {
    key: 'extend',
    header: '',
  },
  {
    key: 'update',
    header: '',
  },
];

export const unsortableHeaderKeys = [
  'name',
  'actionStatus',
  'extend',
  'update',
  'assessmentId',
  'actionCandidateId',
  'timeModifierPercentage',
];
